var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'asc-label',
    _vm.sizeClass,
    _vm.uppercaseClass,
    _vm.typeClass,
    _vm.prependIcon ? 'asc-label-icon asc-label-icon--prepend' : '',
    _vm.appendIcon ? 'asc-label-icon asc-label-icon--append' : '' ],style:({ color: _vm.color })},[(_vm.prependIcon)?[_c('v-icon',{staticClass:"prependIcon",attrs:{"size":"16"}},[_vm._v(_vm._s(_vm.prependIcon))])]:_vm._e(),_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.appendIcon)?[_c('v-icon',{staticClass:"appendIcon",attrs:{"size":"16"}},[_vm._v(_vm._s(_vm.appendIcon))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }